// components/ui/list/custom-row-list.js
import React from 'react';
import PropTypes from 'prop-types';
import { List, ListSubheader } from '@mui/material';

/**
 * sx: Style for the <List> itself
 * rowSx: Style for each item (row)
 * headerSx: Style for header
 */
const CustomRowList = ({ items = [], renderItem, children, sx={}, rowSx = {}, headerSx = {} }) => {

  return (
    <List
      sx={{ minHeight: '60vh', display: 'block', overflowY: 'auto', ...sx }}
      subheader={
        children != null && (
          <ListSubheader
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.50',
              display: 'flex',
              justifyContent: 'space-between',
              p: 1,
              ...headerSx, // Custom header styling
            }}
          >
            {children}
          </ListSubheader>
        )
      }
    >
      {Array.isArray(items) &&
        items.map((item, index) => {
          const rowstyle = {
            backgroundColor: (theme) =>
              index % 2 === 0
                ? theme.palette.mode === 'dark'
                  ? 'rgba(0, 0, 0, 1)'
                  : 'rgba(255, 255, 255, 1)'
                : theme.palette.mode === 'dark'
                ? 'rgba(0, 0, 0, 0.1)'
                : 'rgba(200, 200, 200, 0.1)',
            '&:hover': {
              backgroundColor: 'action.hover',
              cursor: 'pointer',
            },
            py: 1.5,
            px: 1,
            ...rowSx, // Custom item styling
          };
          return (
            <React.Fragment key={index}>{renderItem(item, rowstyle, index)}</React.Fragment>
          );
        })}
    </List>
  );
};

CustomRowList.propTypes = {
  items: PropTypes.array,
  renderItem: PropTypes.func.isRequired,
  children: PropTypes.node, // Only children for the header
  sx: PropTypes.object,
  rowSx: PropTypes.object,
  headerSx: PropTypes.object,
};

export default CustomRowList;
